import React from 'react';
import './App.css';
import {Routes, Route, useParams} from 'react-router-dom';
import Header from './components/structure/Header';
import {BlogManagerRoutes} from './routes/BlogManagerRoutes';
import BlogManagerContainer from './containers/blog/BlogManagerContainer';
import BlogManagerBlogSearchContainer from './containers/blog/BlogManagerBlogSearchContainer';
import BlogManagerNewFromTemplateContainer from './containers/blog/BlogManagerNewFromTemplateContainer';
import BlogManagerNewFACompPostContainer from './containers/blog/BlogManagerNewFACompPostContainer';
import BlogManagerNewFACompResultPostContainer from './containers/blog/BlogManagerNewFACompResultPostContainer';
import PyramidManagerContainer from './containers/pyramid/PyramidManagerContainer';
import ClubSearchContainer from './containers/club/ClubSearchContainer';
import ClubAdd from './components/club/ClubAdd';
import ClubBasicSocialAdd from './components/club/ClubBasicSocialAdd';
import {ProcessingStatusType} from '@nls-2022/nls-bll';
import ClubDetailsContainer from './containers/club/ClubDetailsContainer';
import {
  //ClubDetail,
  PyramidDetailsState,
  PyramidDetailsAction,
  ClubPyramidStatusType,
} from '@nls-2022/nls-bll';
import {usePyramidDetail} from '@nls-2022/nls-bll';
import {PyramidContext} from '@nls-2022/nls-bll';

//<Route path="filter" element={<p>filter</p>} />
//<h1 className="text-3xl font-bold underline">NLS2022</h1>
function App() {
  const [state, dispatchPyramidDetail] = usePyramidDetail();
  const contextProviderValue = {state, dispatchPyramidDetail};
  let params = useParams();

  const {pyramidDetails, pyramidDetailsStatus} = state;

  if (pyramidDetailsStatus === ProcessingStatusType.pending) {
    return (
      <>
        <p>pyramid details loading</p>
      </>
    );
  } else if (pyramidDetailsStatus === ProcessingStatusType.error) {
    return (
      <>
        <p>pyramid details loading errored {pyramidDetailsStatus}</p>
      </>
    );
  }

  return (
    <div className="max-w-1000 mx-auto px-6">
      <Header />
      <PyramidContext.Provider value={contextProviderValue}>
        <Routes>
          <Route path="/" element={<p></p>} />
          <Route path="/NLSAdmin2" element={<p>NLS Admin2</p>} />
          <Route path="/NLSAdmin2/blog" element={<BlogManagerContainer />}>
            <Route path="filter" element={<BlogManagerBlogSearchContainer />} />
            <Route
              path="newfromtemplate"
              element={<BlogManagerNewFromTemplateContainer />}
            />
            <Route
              path="newfromtemplate/facomps"
              element={<BlogManagerNewFACompPostContainer />}
            />
            <Route
              path="newfromtemplate/facompresult"
              element={<BlogManagerNewFACompResultPostContainer />}
            />
            BlogManagerNewFACompPostContainer
          </Route>
          <Route
            path="/NLSAdmin2/pyramidmanager"
            element={<PyramidManagerContainer />}
          ></Route>
          <Route
            path="/clubs"
            element={<ClubSearchContainer resultType={'ByIndex'} />}
          ></Route>
          <Route path="/club/add" element={<ClubAdd />}></Route>
          <Route
            path="/club/socialbasic/add/:clubGuid"
            element={<ClubBasicSocialAdd clubGuid={params.clubGuid!} />}
          ></Route>
          <Route
            path="/club/:url"
            element={<ClubDetailsContainer clubUrl={params.url!} />}
          />
          <Route path="*" element={<p>There's nothing here!</p>} />
        </Routes>
      </PyramidContext.Provider>
    </div>
  );
}

export default App;
